<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <card>
        <el-table
          class="table-striped"
          :header-cell-style="headerCellStyle"
          header-row-class-name="text-danger"
          highlight-current-row
          :cell-style="cellStyle"
          :data="rowData"
        >
          <el-table-column
            label="Title"
            prop="Headline"
          />
          <el-table-column
            label="Description"
            prop="Description"
          />
          <el-table-column label="Link">
            <template slot-scope="props">
              {{ props.row.FileName ? props.row.FileName : props.row.LinkUrl }}
            </template>
          </el-table-column>
          <el-table-column
            class-name="d-none d-md-table-cell action-buttons td-actions"
            align="right"
            width="120"
            label="Actions"
          >
            <template slot-scope="props">
              <p-button
                type="info"
                size="sm"
                class="mt-1 mb-1"
                title="Edit"
                icon
                @click="showEditDialog(props.row)"
              >
                <i class="fa fa-edit" />
              </p-button>
              <p-button
                type="danger"
                size="sm"
                class="mt-1 mb-1"
                title="Delete"
                icon
                @click="deleteConfirm(props.row)"
              >
                <i class="fa fa-times" />
              </p-button>
            </template>
          </el-table-column>
        </el-table>
      </card>
    </div>
    <modal
      :show.sync="showAdd"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      type="mini"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6><i class="fa fa-edit mr-2" /><span class="text-danger">{{ newLink.Id ? "Edit" : "Add" }} Link / File</span></h6>
      </div>
      <ValidationObserver ref="form">
        <form
          @submit.prevent="save"
          id="theForm"
        >
          <ValidationProvider
            name="title"
            rules="required|max:255"
            v-slot="{ passed, failed }"
          >
            <fg-input
              name="title"
              :error="failed ? 'Title is required': null"
              :has-success="passed"
              required
              label="Title"
              placeholder=""
              max-length="255"
              v-model="newLink.Headline"
            />
          </ValidationProvider>
          <fg-input>
            <label for="description">Description</label>
            <ValidationProvider
              name="description"
              rules="max:5000"
              v-slot="{ passed, failed }"
            >
              <textarea
                class="form-control"
                :error="failed ? '5000 character max': null"
                :has-success="passed"
                maxlength="5000"
                type="text"
                placeholder=""
                id="description"
                v-model="newLink.Description"
              />
            </ValidationProvider>
          </fg-input>
          <el-input
            v-model="newLinkFileName"
            disabled
          >
            <p-button
              size="sm"
              slot="append"
              @click="captureTheUrl"
              class="m-0"
            >
              Upload / Link
            </p-button>
          </el-input>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showAdd = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          native-type="submit"
          form="theForm"
          class="mr-2"
        >
          Save
        </p-button>
      </template>
    </modal>
    <button
      type="button"
      class="btn btn-success"
      @click="showAddNewDialog"
    >
      Add New
    </button>
    <capture-file
      :is-photo="false"
      ref="captureFile"
      @url-captured="onCapturedUrl"
    />
  </div>
</template>

<script>
import oops from '@/components/_main/oops.vue'
import linksApi from '@/services/api/links'
import captureFile from '@/components/storage/capture-file.vue'
import Modal from '@/plugins/paper-components/modal.vue'
import { Input } from 'element-ui'

export default {
  name: 'LinksEdit',
  components: {
    oops,
    captureFile,
    Modal,
    [Input.name]: Input
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      loading: true,
      errormessage: null,
      rowData: null,
      newLink: {
        CourseKey: this.$root.courseKey,
        Id: null,
        Headline: null,
        LinkText: null,
        FileName: null,
        LinkUrl: null
      },
      showAdd: false
    }
  },
  computed: {
    newLinkFileName: function () {
      return this.newLink.FileName ? this.newLink.FileName : this.newLink.LinkUrl
    }
  },
  mounted () {
    linksApi.get(this.$root.courseKey)
      .then(response => {
        this.rowData = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    deleteConfirm: function (row) {
      const msg = 'Are you sure you want to delete ' + row.Headline + '?'
      this.$confirm(msg, 'Are you sure?')
        .then(() => {
          this.deleteLink(row)
        })
    },
    deleteLink: function (row) {
      this.disableButtons = true
      linksApi.delete(this.$root.courseKey, row.Id)
        .then(x => {
          this.rowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting the link.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
          this.disableButtons = false
        })
    },
    showEditDialog: function (row) {
      this.newLink.CourseKey = row.CourseKey
      this.newLink.Id = row.Id
      this.newLink.Headline = row.Headline
      this.newLink.LinkText = row.LinkText
      this.newLink.FileName = row.FileName
      this.newLink.LinkUrl = row.LinkUrl
      this.showAdd = true
    },
    showAddNewDialog: function () {
      this.newLink.CourseKey = this.$root.courseKey
      this.newLink.Id = null
      this.newLink.Headline = null
      this.newLink.LinkText = null
      this.newLink.FileName = null
      this.newLink.LinkUrl = null
      this.showAdd = true
    },
    save: function () {
      return this.$refs.form.validate().then(res => {
        this.disableButtons = true
        linksApi.update(this.$root.courseKey, this.newLink)
          .then(x => {
            this.rowData = x
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error updating the link.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(z => {
            this.disableButtons = false
            this.showAdd = false
          })
        return res
      })
    },
    captureTheUrl: function (event) {
      this.$refs.captureFile.showDialog(this.newLink.LinkUrl)
    },
    onCapturedUrl: function (url, fileName) {
      this.newLink.LinkUrl = url
      this.newLink.FileName = fileName
    }
  }
}
</script>
